<template>
  <v-dialog v-model="dialogOpen" width="500" persistent>
    <v-card>
      <v-card-title>New Lead</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-select v-model="kind" :items="kinds" label="Product Kind" 
            :class="(kindErrors.length===0)?'':'mb-n4'" :hide-details="kindErrors.length===0" :error-messages="kindErrors" 
            @input="$v.kind.$touch()" @blur="$v.kind.$touch()"
            :disabled="newLeadLoading" outlined dense></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="business_name" label="Business Name" :disabled="newLeadLoading" hide-details outlined dense></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="customer_name" label="Customer Name" :disabled="newLeadLoading" hide-details outlined dense></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="email_address" label="Email Address" :disabled="newLeadLoading" 
            :class="(email_addressErrors.length===0)?'':'mb-n4'" :hide-details="email_addressErrors.length===0" :error-messages="email_addressErrors" 
            @input="$v.email_address.$touch()" @blur="$v.email_address.$touch()"
            outlined dense></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="phone_number" label="Phone Number" :disabled="newLeadLoading" 
            :class="(phone_numberErrors.length===0)?'':'mb-n4'" :hide-details="phone_numberErrors.length===0" :error-messages="phone_numberErrors" 
            @input="$v.phone_number.$touch()" @blur="$v.phone_number.$touch()"
            outlined dense></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="mobile_number" label="Mobile Number" :disabled="newLeadLoading" 
            :class="(mobile_numberErrors.length===0)?'':'mb-n4'" :hide-details="mobile_numberErrors.length===0" :error-messages="mobile_numberErrors" 
            @input="$v.mobile_number.$touch()" @blur="$v.mobile_number.$touch()"
            outlined dense></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete v-model="lead_source" label="Lead Source" :items="getLeadSources" :error-messages="leadSourceErrors" :hide-details="leadSourceErrors.length===0" @change="$v.lead_source.$touch()" @blur="$v.lead_source.$touch()" :disabled="newLeadLoading||optionsLoading" :loading="optionsLoading" outlined dense required></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete v-model="channel" label="Channel" :items="getLeadChannelsForNew" :error-messages="channelErrors" :hide-details="channelErrors.length===0" @change="$v.channel.$touch()" @blur="$v.channel.$touch()" :disabled="newLeadLoading||optionsLoading" :loading="optionsLoading" outlined dense required></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :disabled="newLeadLoading" :loading="newLeadLoading">CREATE</v-btn>
        <v-btn color="primary" small outlined @click="close">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState,mapActions,mapGetters } from 'vuex';
  import { validationMixin } from "vuelidate";
  import { required,email,numeric } from "vuelidate/lib/validators";
  import { phoneNumberValidation } from "../../validators";
  export default {
    mixins: [validationMixin],
    validations: {
      lead_source: {required},
      channel: {required},
      kind: {required},
      email_address: {email},
      phone_number: {numeric,phoneNumberValidation},
      mobile_number: {numeric,phoneNumberValidation},
    },
    computed: {
      ...mapGetters("daily", ['getNewLeadId']),
      ...mapGetters("globals", ['hasUserGotRole','getUserRoles']),
      ...mapGetters('leads',['getLeadSources','getLeadChannelsForNew']),
      ...mapState('daily',['newLeadLoading']),
      kindErrors() {
        const errors = [];
        if (!this.$v.kind.$dirty) return errors;
        !this.$v.kind.required && errors.push("Product kind must be selected");
        return errors;
      },
      email_addressErrors() {
        const errors = [];
        if (!this.$v.email_address.$dirty) return errors;
        !this.$v.email_address.email && errors.push("Must be a valid email address");
        return errors;
      },
      phone_numberErrors() {
        const errors = [];
        if (!this.$v.phone_number.$dirty||this.phone_number==='') return errors;
        (!this.$v.phone_number.numeric&&this.phone_number!=='') && errors.push("Must contain numbers only");
        (!this.$v.phone_number.phoneNumberValidation&&this.phone_number!=='') && errors.push("Must be a valid phone number");
        return errors;
      },
      mobile_numberErrors() {
        const errors = [];
        if (!this.$v.mobile_number.$dirty||this.mobile_number==='') return errors;
        (!this.$v.mobile_number.numeric&&this.mobile_number!=='') && errors.push("Must contain numbers only");
        (!this.$v.mobile_number.phoneNumberValidation&&this.mobile_number!=='') && errors.push("Must be a valid mobile number");
        return errors;
      },
      leadSourceErrors() {
        const errors = [];
        if (!this.$v.lead_source.$dirty) return errors;
        !this.$v.lead_source.required && errors.push("Lead Source is required");
        return errors;
      },
      channelErrors() {
        const errors = [];
        if (!this.$v.channel.$dirty) return errors;
        !this.$v.channel.required && errors.push("Channel is required");
        return errors;
      },
      kinds(){
        return [
          {text:'VoIP',value:'VOIP',disabled:!this.hasUserGotRole('can-make-voip-leads')},
          {text:'Telco',value:'TELCO',disabled:!this.hasUserGotRole('can-make-telco-leads')},
          {text:'Website',value:'WEB',disabled:!this.hasUserGotRole('can-make-web-leads')}
        ];
      },
      nonRequiredFields(){
        return !this.$v.email_address.$error&&!(this.$v.mobile_number.$error&&this.mobile_number!=='')&&!(this.$v.phone_number.$error&&this.phone_number!=='');
      },
    },
    props: ['dialogOpen'],
    data() {
      return {
        optionsLoading: true,
        channel: '',
        lead_source: '',
        kind: '',
        business_name: '',
        customer_name: '',
        email_address: '',
        phone_number: '',
        mobile_number: '',
      }
    },
    watch: {
      async dialogOpen(val) {
        if(val){
          await this.getLeadOptions();
          this.optionsLoading = false;
        }
      }
    },
    methods: {
      ...mapActions('leads', ['getLeadOptions']),
      ...mapActions('daily', ['loadDailyLeads','createNewLead']),
      async submit() {
        this.$v.$touch();
        if(!this.$v.channel.$invalid&&!this.$v.lead_source.$invalid&&!this.$v.kind.$invalid) {
          let data = {
            kind: this.kind,
            business_name: this.business_name,
            name: this.customer_name,
            email_address: this.email_address,
            phone_number: this.phone_number,
            mobile_number: this.mobile_number,
            source: this.lead_source,
            channel: this.channel,
          };
          let success = await this.createNewLead(data);
          if(success){
            this.close();
            this.$router.push(`/leads/${this.getNewLeadId.id}/`);
          }
        }
      },
      resetForm(){
        this.kind = '';
        this.business_name = '';
        this.customer_name = '';
        this.email_address = '';
        this.phone_number = '';
        this.mobile_number = '';
        this.channel = '';
        this.lead_source = '';
        this.$v.$reset();
      },
      close() {
        this.resetForm();
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
